import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";

import { getLocale, getAltFormat, clearDisable } from "../lib/flatpickr-utils";
import weeklyRange from "../plugins/flatpickr/weeklyRange";
import decorate from "../plugins/flatpickr/decorate";

// Connects to data-controller="daterange-picker"
export default class extends Controller {
  static targets = ["input", "position"];

  static values = {
    locale: String,
    minDate: String,
    maxDate: String,
    maxWeeks: Number,
    pausedDates: Array, // Array of {from, to}
    suspendedDates: Array, // Array of {from, to}
    confirmedDates: Array, // Array of {date, from, to}
    potentialDeliveries: Array, // Array of dates as string
  };

  connect() {
    this.picker = flatpickr(this.inputTarget, {
      inline: true,
      appendTo: this.positionTarget,
      locale: getLocale(this.localeValue),
      mode: "range",
      showMonths: 2,
      dateFormat: "Y-m-d",
      altInput: true,
      altFormat: getAltFormat(this.localeValue),
      ...(this.#disabledDateRanges().length > 0
        ? { disable: this.#disabledDateRanges() }
        : {}),
      ...(this.hasMinDateValue ? { minDate: new Date(this.minDateValue) } : {}),
      ...(this.hasMaxDateValue ? { maxDate: new Date(this.maxDateValue) } : {}),
      plugins: [
        weeklyRange({
          ...(this.hasMaxWeeksValue ? { maxWeeks: this.maxWeeksValue } : {}),
        }),
        decorate({
          redBg: this.pausedDatesValue,
          yellowBg: this.suspendedDatesValue,
          greenBgAndDots: this.confirmedDatesValue.map(({ date }) => date),
          greenBg: this.potentialDeliveriesValue,
        }),
      ],
    });

    if (this.#disabledDateRanges().length === 0) {
      this.clearDisable();
    }
  }

  disconnect() {
    this.picker = null;
  }

  clear() {
    this.clearDisable();
    this.picker.clear();
  }

  clearDisable() {
    clearDisable(
      this.picker,
      this.hasMaxWeeksValue ? this.maxWeeksValue : undefined,
    );
  }

  #disabledDateRanges() {
    return this.pausedDatesValue.concat(
      this.confirmedDatesValue.map(({ from, to }) => ({ from, to })),
    );
  }
}
